import React, { FC, useEffect, useState } from "react";
import MainLayout from "../../Layouts/MainLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { service } from "../../../services/AxiosServices";
import CustomTable from "../atoms/CustomTable";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  styled
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Spinner from "../atoms/Spinner";
import SectionHeader from "../molecules/SectionHeader";


const StyledAccordionDetails = styled(AccordionDetails)`
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 500px;
  overflow-y: auto;
  padding: 16px;
`;

const ResponseWrapper = styled('div')`
  white-space: pre-wrap;
  word-break: break-word;
`;

interface TaskResponse {
  task_id: string;
  description?: string;
  responses: Array<{
    agent_name: string;
    response: string;
  }>;
  response: string;
}

const Output: FC = () => {
  const [outputResponse, setOutputResponse] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const crewName = location.state?.crewName || "crew";
  const { id } = useParams();
  const response = location.pathname.toLowerCase().startsWith("/response");

  useEffect(() => {
    const expectedOutput = async () => {
      try {
        setLoading(true);
        const response = await service<{ tasks: TaskResponse[] }>(
          "api/response",
          "post",
          {
            crew_id: id,
          }
        );
        const formattedData = response?.data?.tasks.map((ele) => ({
          taskId: ele.task_id,
          title: ele?.description || "Output response",
          finetunedData: ele?.responses?.length
            ? ele.responses.map((res) => {
              // const isLongResponse = res.response.length > 80;
              return (
                <ResponseWrapper key={res.agent_name}>

                  <Accordion
                    sx={{
                      '& .MuiAccordionSummary-content': {
                        margin: '8px 0',
                      },
                      '& .MuiAccordionDetails-root': {
                        padding: '8px 16px 16px',
                      }
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: 'rgba(0, 0, 0, 0.03)',
                        minHeight: '48px',
                        '&.Mui-expanded': {
                          minHeight: '48px',
                        }
                      }}
                    >
                      <Typography sx={{ fontWeight: 500 }}>{res.agent_name}</Typography>
                    </AccordionSummary>
                    <StyledAccordionDetails>
                      <Typography component="div" sx={{ lineHeight: 1.6 }}>
                        {res.response}
                      </Typography>
                    </StyledAccordionDetails>
                  </Accordion>

                  {/* <>
                        <Typography component="div" sx={{ fontWeight: 500, mb: 1 }}>
                          Agent name: {res.agent_name}
                        </Typography>
                        <Typography component="div" sx={{ mb: 2 }}>
                          Response: {res.response}
                        </Typography>
                      </> */}

                </ResponseWrapper>
              );
            })
            : "No responses available",
          finalOutput: ele?.response || "Final output not available",
        }));
        setOutputResponse(formattedData || []);
      } catch (err) {
        console.error("Error fetching output:", err);
      } finally {
        setLoading(false);
      }
    };
    if (id) {
      expectedOutput();
    }
  }, [id]);

  const rows = outputResponse;
  const columns = ["Title", "Finetuned Data", "Final Output"];
  const taskId = outputResponse.map((ele) => ele.task_id);
  const actionButtons = [
    {
      alt: response ? "View" : "Finetune",
      className: "btn btn-primary",
      onClick: (rowIndex: number) => {
        const taskId = rows[rowIndex]?.taskId;
        navigate(`/finetune_overview/${taskId}`, {
          state: { response, id, crewName },
        });
      },
    },
  ];

  return (
    <MainLayout>
      <SectionHeader  back = {true}title={`Output: ${crewName}`} />
      {loading ? (
        <Spinner />
      ) : outputResponse.length > 0 ? (
        <div className="overflow-x-auto">
          <CustomTable rows={rows} columns={columns} actionButtons={actionButtons} />
        </div>
      ) : (
        <p className="text-center">No outputs are available</p>
      )}
    </MainLayout>
  );
};

export default Output;